import { Component, OnInit } from '@angular/core';
import { Ccenter } from '../models';
import { ActivatedRoute } from '@angular/router';
import { GridApi, GridOptions } from 'ag-grid-community';
import { GridCriteria } from '../models/grid-criteria';
import { CcenterExportService } from '../services'; 
import { noCaseStringComparer } from 'src/app/shared/no-case-string-comparer';

@Component({
  selector: 'app-ccimprovements',
  templateUrl: './ccf-improvements.component.html',
})
export class CcimprovementsComponent implements OnInit {
    ccenters: Ccenter[];
    rows = [];
    filterdRows = [];
    private gridApi: GridApi;
    gridOptions: GridOptions;

    constructor(private readonly route: ActivatedRoute, private readonly ccenterExportService: CcenterExportService) {}

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.updateCcenter();
        });
        this.gridOptions = <GridOptions>{
            popupParent: document.querySelector("body"),
            columnDefs: [{
                headerName: "Cost Center",
                field: "costCenter",
                filter: 'agTextColumnFilter',
                filterParams: {
                    filterOptions: ['startsWith', 'contains'],
                    suppressAndOrCondition: true
                }
            },
            {
                headerName: "Description",
                field: "description",
                filter: 'agTextColumnFilter',
                filterParams: {
                    filterOptions: ['startsWith', 'contains'],
                    suppressAndOrCondition: true
                },
                comparator: noCaseStringComparer
            },
            ],
            defaultColDef: {
                sortable: true,
                unSortIcon: true
            },
            animateRows: true,
            suppressMenuHide: true
        }
    }

    updateCcenter() {
        this.route.data.subscribe(({ ccenters }: { ccenters: Ccenter[]}) => {
            this.ccenters = ccenters;
        });
    }

    exportToExcel() {
        var rows = [];
        const filename = "CctrImprovements";
        const excelHeading = "Cost Center - Improvements - Iact 6710 & 6715";

        this.gridApi.forEachNodeAfterFilter(node => {
            rows.push(node.data)
        })
        var criteria = this.gridApi.getFilterModel();
        var costCenterFilter = new GridCriteria(criteria.costCenter);
        var descriptionFilter = new GridCriteria(criteria.description);
        this.ccenterExportService.exportToExcel(rows, costCenterFilter, descriptionFilter, filename, excelHeading);
    }

    onGridReady($event) {
        this.gridApi = $event.api as GridApi;
        this.ccenters.forEach(ccenter => {
            this.rows.push({ costCenter: ccenter.ccenterElementCode, description: ccenter.ccenterDescription });
        });
        this.gridApi.setRowData(this.rows);
        this.gridApi.sizeColumnsToFit();
    }
}
